import React from "react";
import "../../styles/AboutUsBanner.css";
import myvideo from '../../assets/heroca-home.mp4'

const HerocaHomeBanner = () => {
  return (
    <section className="about-us-banner">
      <video
        className="aboutus-banner-video"
        src={myvideo}
        autoPlay
        loop
        muted
      ></video>
      <div className="aboutus-overlay">
        <div className="aboutus-content">
          <h1>HORECA Your Trusted Partner for Premium Food Supplies.</h1>
          <p>Serving the hospitality industry with exceptional quality and reliability.</p>
        </div>
      </div>
    </section>
  );
};

export default HerocaHomeBanner;
